import { FaClipboardList } from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
import { MdAccessTime, MdLocationOff } from "react-icons/md";

export const shopifyData = [
    {
      title: "IP Restriction",
      video: true,
      videoId: "MkakxgM7MZs",
      videoType: "youtube",
      icon: <MdLocationOff className='text-white fs-5' />
    },
    {
      title: "Clipboard Restriction",
      video: true,
      videoId: "6WVY9LMZEP4",
      videoType: "youtube",
      icon: <FaClipboardList className='text-white fs-5' />
    },
    {
      title: "Time-based Restriction",
      video: true,
      videoId: "sLjVwhIFFYY",
      videoType: "youtube",
      icon: <MdAccessTime className='text-white fs-5' />
    },
    {
      title: "Location-based Restriction",
      video: true,
      videoId: "40f6Sl35Xhs",
      videoType: "youtube",
      icon: <FaMapLocationDot className='text-white fs-5' />
    }
  ]